import { useState } from 'react';
import { GitBranch, ArrowDown, Upload } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useToast } from "@/components/ui/use-toast";

const GitControls = () => {
  const { toast } = useToast();
  const [showPushConfirm, setShowPushConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePull = async () => {
    setIsLoading(true);
    try {
      const result = await fetch('http://localhost:3001/api/git/pull', {
        method: 'POST',
      });
      
      if (!result.ok) throw new Error('Pull failed');
      
      toast({
        title: "Repository aktualisiert",
        description: "Die neuesten Änderungen wurden erfolgreich heruntergeladen.",
      });
    } catch (error) {
      toast({
        title: "Fehler beim Aktualisieren",
        description: "Es gab ein Problem beim Herunterladen der Änderungen.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handlePush = async () => {
    setIsLoading(true);
    try {
      const result = await fetch('http://localhost:3001/api/git/push', {
        method: 'POST',
      });
      
      if (!result.ok) throw new Error('Push failed');
      
      toast({
        title: "Änderungen hochgeladen",
        description: "Ihre Änderungen wurden erfolgreich zu GitHub hochgeladen.",
      });
    } catch (error) {
      toast({
        title: "Fehler beim Hochladen",
        description: "Es gab ein Problem beim Hochladen der Änderungen.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      setShowPushConfirm(false);
    }
  };

  return (
    <>
      <div className="fixed bottom-20 right-4 z-50">
        <DropdownMenu>
          <DropdownMenuTrigger disabled={isLoading} className="bg-black/20 backdrop-blur-sm shadow-lg rounded-full p-3 hover:bg-black/30 text-white transition-colors">
            <GitBranch className={`h-5 w-5 ${isLoading ? 'animate-spin' : ''}`} />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem disabled={isLoading} onSelect={() => handlePull()}>
              <ArrowDown className="mr-2 h-4 w-4" />
              GitHub aktualisieren
            </DropdownMenuItem>
            <DropdownMenuItem disabled={isLoading} onSelect={() => setShowPushConfirm(true)}>
              <Upload className="mr-2 h-4 w-4" />
              Änderungen hochladen
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <AlertDialog open={showPushConfirm} onOpenChange={setShowPushConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Sind Sie sicher?</AlertDialogTitle>
            <AlertDialogDescription>
              Diese Aktion wird alle Ihre lokalen Änderungen auf GitHub hochladen und bestehende Dateien überschreiben.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Abbrechen</AlertDialogCancel>
            <AlertDialogAction onClick={handlePush}>Ja, hochladen</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default GitControls;